"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Jira = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const JiraSvg = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#2684FF",
    d: "m20.785 11.44-8.009-8.606L12 2 5.972 8.478 3.216 11.44a.835.835 0 0 0 0 1.12l5.507 5.918L12 22l6.028-6.478.094-.1 2.663-2.862a.835.835 0 0 0 0-1.12M12 14.957 9.249 12 12 9.043 14.751 12z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "url(#jira__a)",
    d: "M12 9.027C10.21 7.089 10.202 3.95 11.98 2L6 8.475 9.255 12z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "url(#jira__b)",
    d: "M14.742 12 12 14.962c.864.933 1.35 2.2 1.35 3.52S12.864 21.066 12 22l6-6.481z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
      id: "jira__a",
      x1: 10.061,
      x2: 7.131,
      y1: 6.033,
      y2: 8.738,
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: 0.18,
        stopColor: "#0052CC"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: 1,
        stopColor: "#2684FF"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
      id: "jira__b",
      x1: 13.959,
      x2: 16.874,
      y1: 17.917,
      y2: 15.218,
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: 0.18,
        stopColor: "#0052CC"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: 1,
        stopColor: "#2684FF"
      })]
    })]
  })]
});
const Jira = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread(_objectSpread({}, props), {}, {
  component: JiraSvg
}));
exports.Jira = Jira;